import { ApolloClient, InMemoryCache, HttpLink, ApolloLink, concat, Operation, NextLink } from "@apollo/client";
import { ConstValues } from "../utils/constValues";

const httpLink = new HttpLink({ uri: ConstValues.GraphQL.seekUrl });

const authMiddleware = new ApolloLink((operation: Operation, forward: NextLink) => {
  // add the authorization to the headers
  const browserToken = localStorage.getItem("browserToken");
  const token = browserToken ? JSON.parse(browserToken)?.data?.access_token : "";

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  }));
  return forward(operation);
});

const apolloClient = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache(),
});
export default apolloClient;
